<template>
  <div>
    <br />
    <div>
      <base-checkbox class="mb-3" v-model="override_product_series"
        >Product Series</base-checkbox
      >
    </div>
    <div class="row ml-3">
      <div class="col-md-11">
        <p>
          Tracking of the introduction date of item, as well as the repeat
          orders
        </p>

        <div class="row">
          <div class="col">
            <base-input label="Series Name">
              <a-select 
                v-model="product_series.series_name"
                showSearch 
                placeholder="Select Series Name"
                optionFilterProp="children"
                style="width: 100%"
                :filterOption="filterOption"
                :disabled="override_product_series != true" 
              >
                <a-select-option
                  v-for="product_series_option in productSeriesOptions"
                  :key="product_series_option.key"
                  :value="product_series_option.name"
              
                > {{product_series_option.name}}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
          <div class="col">
            <base-input label="Series Date">
              <a-date-picker
                name="series_date"
                class="series_date_field"
                :format="dateFormat"
                :default-value="null"
                v-model="product_series.series_date"
                placeholder="Select date"
                @change="updateProductSeriesSeriesDate"
                :disabled="override_product_series != true"
                required
              />
            </base-input>
          </div>
        </div>
        <div class="float-right">
          <template v-if="productseriesButton === 'add'">
            <button
              type="button"
              class="btn btn-sm btn-primary float-right"
              name="submit"
              @click="productseriesHandleAdd"
              :disabled="override_product_series != true"
            >
              Add
            </button>
          </template>

          <template v-else-if="productseriesButton === 'delete'">
            <a-popconfirm
              title="Delete Product Series?"
              @confirm="() => productseriesDelete(productseriesKey)"
            >
              <a
                href="javascript:;"
                class="btn btn-warning btn-sm"
                style="color: #fff"
                >Delete</a
              >
            </a-popconfirm>
          </template>
        </div>

        <br />
        <br />
      </div>

      <!-- product series table -->
      <div class="col-md-11">
        <a-table
          :columns="productseriesColumns"
          :dataSource="productseriesData"
          :pagination="false"
          :scroll="{ y: 400 }"
          :customRow="changeProductSeriesButton"
        >
        </a-table>
      </div>
      <!-- end product series table -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

var component_x;
// product series columns
const productseriesColumns = [
  {
    title: "Series Name",
    dataIndex: "series_name",
    scopedSlots: {
      customRender: "series_name",
    },
  },
  {
    title: "Series Date",
    dataIndex: "series_date",
    scopedSlots: {
      customRender: "series_date",
    },
  },
];
// end product series columns

const productseriesData = []; // product series array
export default {
  data() {
    return {
      //  product series data
      productSeriesOptions: [
        {key: "new", name: "New"},
        {key: "repeat", name: "Repeat"},
        {key: "repeat_1", name: "Repeat 1"},
        {key: "repeat_2", name: "Repeat 2"},
        {key: "repeat_3", name: "Repeat 3"},
        {key: "repeat_4", name: "Repeat 4"},
        {key: "repeat_5", name: "Repeat 5"},
        {key: "repeat_6", name: "Repeat 6"},
        {key: "repeat_7", name: "Repeat 7"},
        {key: "repeat_8", name: "Repeat 8"},
        {key: "repeat_9", name: "Repeat 9"},
        {key: "repeat_10", name: "Repeat 10"},
      ],
      productseriesKey: "",
      override_product_series: false,
      productseriesButton: "add", //change button to add and delete
      dateFormat: "YYYY/MM/DD",
      productseriesCount: 1, // temporary key
      productseriesData, // array item to push objects
      productseriesColumns, // table columns
      product_series: {
        key: null,
        series_name: "",
        series_date: null,
        status: "",
      },
      // end product series data
    };
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "parameters",
      "categoriesOptions",
    ]),
  },

  mounted: async function () {
    component_x = this;
    component_x.settingCode = component_x.$attrs.settingCode;
    component_x.productseriesData = []; //product series
  },

  watch: {
    productseriesData: {
      handler: async function () {
        var configValues = {};
        configValues[this.settingCode] = this.productseriesData;
        component_x.$emit("changeValue", configValues);
      },
      deep: true,
    },
    override_product_series: function () {
      if (this.override_product_series == false) {
        this.productseriesData = [];
      }
    },
  },

  methods: {
    moment,

    updateProductSeriesSeriesDate(date) {
      this.product_series.series_date = moment(date, "YYYY/MM/DD").format(
        "MMMM DD, YYYY"
      );

      // use for changing delete button on product_series
      if (this.productseriesButton == "delete") {
        this.productseriesButton = "add";
      }
    },

    changeProductSeriesButton(record) {
      return {
        on: {
          click: () => {
            this.productseriesButton = "delete";
            this.productseriesKey = record.key;
          },
        },
      };
    },

    productseriesDelete(key) {
      const dataSource = [...this.productseriesData];
      this.productseriesData = dataSource.filter((item) => item.key !== key);
      this.productseriesButton = "add";
    },

    productseriesHandleAdd: async function () {
      const productseriesCount = this.productseriesCount;

      this.tableErrors = [];
      const product_series = this.product_series;

      // product series validation

      if (!this.product_series.series_name) {
        this.tableErrors.push("Series Name Required");
      }

      if (!product_series.series_date) {
        this.tableErrors.push("Series Date Required");
      }

      if (
        this.productseriesData.find(
          (object) =>
            object.series_name.toLowerCase() ===
            product_series.series_name.toLowerCase()
        )
      ) {
        this.tableErrors.push("Series Name already exists");
      }

      if (this.tableErrors.length <= 0) {
        product_series.key = productseriesCount;
        product_series.status = "A";
        this.productseriesData.push({ ...product_series });

        this.productseriesCount = productseriesCount + 1;
        this.product_series = [];
      } else {
        alert(this.tableErrors.join("\r\n"));
      }
    },
    // end of product series methods
  },
};
</script>
